var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","props":_vm.defaultProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }